import { gql } from '@apollo/client';
import { useForm } from 'components/form/Form';
import { useValue } from 'components/form/hook/useValue';
import { useUser } from 'components/user/UserProvider';
import { classNames } from 'libs/react';
import { useIdent } from 'libs/react';
import { useIf } from 'libs/react';
import { useQuery } from 'libs/react';
import { useState } from 'libs/react';
import { MediaSelector } from '../MediaSelector';
import { FormFieldError } from 'components/form/FormFieldError';
import { FormFieldInfos } from 'components/form/FormFieldInfos';
import { FormFieldLabel } from 'components/form/FormFieldLabel';
import { MediaFragment } from 'graphql/Media/fragments/MediaFragment';
import { Fragment } from 'libs/react';
import { React } from 'libs/react';
import './FormMediaSelector.scss';
/**
 * @const SelectorMediasQuery
 * @since 1.0.0
 */
export const SelectorMediasQuery = gql `
  query SelectorMediasQuery($input: MediasInput, $selectedInput: MediasInput) {
    selectedMedias: medias(input: $selectedInput) {
      ...MediaFragment
    }
    medias: medias(input: $input) {
      ...MediaFragment
    }
  }

  ${MediaFragment}
`;
/**
 * @component FormMediaSelector
 * @since 1.0.0
 */
export function FormMediaSelector(props) {
    let { name, size, style, infos, label, error, types, disabled, required } = Object.assign({ size: 'medium', style: 'normal' }, props);
    const form = useForm();
    const { isContactUser, isManager } = useUser();
    const [ident] = useIdent('form-media-selector');
    const [selectedValue, setSelectedValue] = useValue(name, props.value, null);
    const [focused, setFocused] = useState(false);
    const restricted = isContactUser() || isManager();
    const [data] = useQuery(SelectorMediasQuery, {
        variables: {
            selectedInput: {
                query: {
                    field: 'ids',
                    value: selectedValue,
                    operator: 'IN'
                }
            },
            input: {
                query: {
                    field: 'ids',
                    value: props.values ? props.values.join() : [],
                    operator: 'IN'
                },
                restricted: restricted || undefined
            }
        }
    });
    /**
     * @function onMediaSelectorSelect
     * @since 1.0.0
     * @hidden
     */
    function onMediaSelectorSelect(medias) {
        if (disabled) {
            return;
        }
        if (Array.isArray(medias)) {
            medias = medias[0];
        }
        setSelectedValue(medias ? medias.id : null);
    }
    useIf(focused, props.onFocus, props.onBlur);
    // useWatch(() => {
    // 	if (props.onChange) {
    // 		props.onChange(values)
    // 	}
    // }, [values])
    if (error == null) {
        error = form.getError(name);
    }
    const className = classNames('form-media-selector', 'form-media-selector--' + style, { 'form-media-selector--is-required': required }, { 'form-media-selector--is-disabled': disabled }, { 'form-media-selector--is-focused': focused }, { 'form-media-selector--has-label': label }, { 'form-media-selector--has-value': selectedValue }, 
    // { 'form-media-selector--has-media': values.length > 0 },
    { 'form-media-selector--has-error': error }, props.className);
    return (React.createElement(Fragment, null,
        React.createElement("div", { className: className },
            React.createElement("div", { className: "form-media-selector-field" },
                React.createElement("div", { className: "form-media-selector-field-head" },
                    React.createElement(FormFieldLabel, { className: "form-media-selector-label", style: style, label: label, ident: ident, required: required, disabled: disabled }),
                    React.createElement(FormFieldInfos, { className: "form-media-selector-infos", style: style, infos: infos })),
                React.createElement("div", { className: "form-media-selector-field-body" },
                    React.createElement(MediaSelector, { size: size, style: style, types: types, values: data === null || data === void 0 ? void 0 : data.selectedMedias, medias: data === null || data === void 0 ? void 0 : data.medias, onSelect: onMediaSelectorSelect, multiple: false })))),
        React.createElement(FormFieldError, { error: error })));
}
